<template>
  <div>
    <!-- {{ deviceType }} -->
    <ErrorBoundary>
      <router-view :device-type="deviceType"/>
    </ErrorBoundary>
     <!-- <router-view/> -->
  </div>
</template>

<script>
import './assets/css/main.css'
import './assets/css/font.css'
import './assets/css/style.css'
import ErrorBoundary from './components/ErrorBoundary.vue'

export default {
  components: {
    ErrorBoundary
  },
  data() {
    return {
      deviceType: null
    }
  },
  created() {
    this.detectDevice();
  },
  errorCaptured(err, instance, info) {
    // Log error untuk debugging
    console.log('App level error captured:', err, info)
    
    // Jangan tangkap error yang berhubungan dengan navigation atau role selection
    const isNavigationError = err.message?.includes('navigation') ||
                             err.message?.includes('route') ||
                             info.includes('router-view') ||
                             info.includes('role')
    
    if (isNavigationError) {
      console.log('Navigation error, allowing normal handling')
      return true // Biarkan error propagate ke handler normal
    }
    
    // Untuk error lainnya, biarkan ErrorBoundary yang handle
    return true
  },
  methods: {
    detectDevice() {
      const userAgent = navigator.userAgent;

      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        this.deviceType = 'Mobile';
        
      }else{
        this.deviceType = 'Desktop';
        
      }
      
      // if (/mobile/i.test(userAgent)) {
      //   this.deviceType = 'Mobile';
      // } else if (/tablet/i.test(userAgent)) {
      //   this.deviceType = 'Tablet';
      // } else {
      //   this.deviceType = 'Desktop';
      // }
    }
  }
}
</script>